import { createSelector } from '@ngrx/store';
import { selectFeature } from 'src/app/clinical/store/selectors/clinical.selectors';

export const selectSubmittalNotes = (submittalId: number) =>
    createSelector(selectFeature, (state) => {
        return state.clinicalReviewHistory.notes.find((h) => h.submittalId === submittalId) ?? null;
    });

export const selectCandidateClinicalHistory = (candidateId: number) =>
    createSelector(selectFeature, (state) => {
        return state.clinicalReviewHistory.candidateId === candidateId ? state.clinicalReviewHistory.history : [];
    });
